module.exports = __webpack_public_path__ + "static/media/kitchen.660a536f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/other/kitchen.svg
// module id = 864
// module chunks = 0